import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import SiteLayout from "@/components/feature/SiteLayout";
import Home from "../pages/home/page";
import Category from "../pages/category/page";
import Detail from "../pages/detail/page";
import Special from "../pages/special/page";
import Search from "../pages/search/page";
import About from "../pages/about/page";
import Contact from "../pages/contact/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <SiteLayout />,
    children: [
      {
        index: true,
        element: <Home />,
      },
      {
        path: "category",
        element: <Category />,
      },
      {
        path: "detail/:movieId",
        element: <Detail />,
      },
      {
        path: "special",
        element: <Special />,
      },
      {
        path: "search",
        element: <Search />,
      },
      {
        path: "about",
        element: <About />,
      },
      {
        path: "contact",
        element: <Contact />,
      },
      {
        path: "*",
        element: <NotFound />,
      },
    ],
  },
];

export default routes;